import { isValidPhoneExt, phoneNoExpExt } from '../validators/phone'

const phoneFormatter = function (v) {
  let r = ''

  if (v !== null) {
    r = v
    const p = v.replace(/([^0-9+-])/g, '').trim()
    if (p !== '') {
      if (isValidPhoneExt(p)) {
        const partCountryCode = p.replace(phoneNoExpExt, '$2')
        const partPrefix = p.replace(phoneNoExpExt, '$5')
        const partNo = p.replace(phoneNoExpExt, '$6')
        r = (partCountryCode + (partCountryCode !== '0' ? ' ' : '') + partPrefix + ' ' + partNo).trim()
      }
    } else {
      r = ''
    }
  }

  return r
}
const knownNDCs = [
  '1501',
  '1502',
  '1505',
  '1508',
  '1510',
  '1511',
  '1512',
  '1513',
  '1514',
  '1515',
  '1516',
  '1517',
  '1518',
  '1519',
  '1520',
  '1521',
  '1522',
  '1523',
  '1525',
  '1526',
  '1531',
  '1551',
  '1555',
  '1556',
  '1563',
  '1566',
  '1567',
  '1570',
  '1573',
  '1575',
  '1576',
  '1577',
  '1578',
  '1579',
  '1588',
  '1590',
  '155',
  '160',
  '162',
  '163',
  '170',
  '171',
  '172',
  '173',
  '174',
  '175',
  '176',
  '177',
  '178',
  '179'
]
const phoneFormatterWithSpaces = function (v) {
  let p = v.replace(/([^0-9+-])/g, '').trim()
  if (p !== '') {
    if (!isValidPhoneExt(p)) {
      // check if number starts with country code with missing 00 or +
      if (p.substring(0, 2) === '49') {
        p = '+' + p
      }
      // check if user entered a MSISDN starting without zero and country code, i.e. 17323456
      // check if input starts with a known ndc
      for (let n = 0; n < knownNDCs.length; n++) {
        if (p.substr(0, knownNDCs[n].length) === knownNDCs[n]) {
          p = '+49' + p
          break
        }
      }
    }

    if (isValidPhoneExt(p)) {
      const partCountryCode = p.replace(phoneNoExpExt, '$2')
      const partPrefix = p.replace(phoneNoExpExt, '$5')
      const partNo = p.replace(phoneNoExpExt, '$6')
      let formatted = (partCountryCode + (partCountryCode !== '0' ? ' ' : '') + partPrefix + ' ' + partNo).trim()

      // ensure we have a country code prefix
      if (formatted.substr(0, 1) !== '+') {
        // replace a double zero
        if (formatted.substr(0, 2) === '00') {
          formatted = '+' + formatted.substr(2)
        } else if (formatted.substr(0, 1) === '0') {
          formatted = '+49' + formatted.substr(1)
        } else if (formatted.substr(0, 1) === '1') {
          formatted = '+49' + formatted
        }
      }

      p = formatted
    }
  } else {
    p = ''
  }

  return p
}

export { phoneFormatter, phoneFormatterWithSpaces }

export default {
  methods: {
    phoneFormatter,
    phoneFormatterWithSpaces
  }
}
